import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Import and register controllers
import CounterController from "./counter_controller";
application.register("counter", CounterController);

import ModalController from "./modal_controller";
application.register("ui-modal", ModalController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import TableController from "./table_controller";
application.register("table", TableController);

import TableRowController from "./table_row_controller";
application.register("table-row", TableRowController);

import TableSelectionController from "./table_selection_controller";
application.register("table-selection", TableSelectionController);

import InfiniteScrollController from "./infinite_scroll_controller";
application.register("infinite-scroll", InfiniteScrollController);

import AlertController from "./alert_controller";
application.register("ui-alert", AlertController);

import SubmitOnEnterController from "./submit_on_enter_controller";
application.register("submit-on-enter", SubmitOnEnterController);

import FileUploadController from "./file_upload_controller";
application.register("file-upload", FileUploadController);

import AvatarUploadController from "./avatar_upload_controller";
application.register("avatar-upload", AvatarUploadController);

import CoverUploadController from "./cover_upload_controller";
application.register("cover-upload", CoverUploadController);

import ClickableCardController from "./clickable_card_controller";
application.register("clickable-card", ClickableCardController);

import SortableController from "./sortable_controller";
application.register("sortable", SortableController);

import SectionCollapseController from "./section_collapse_controller";
application.register("section-collapse", SectionCollapseController);

import ExerciseEditorController from "./exercise_editor_controller";
application.register("exercise-editor", ExerciseEditorController);

import TypePickerController from "./type_picker_controller";
application.register("type-picker", TypePickerController);

import TypePickerGroupController from "./type_picker_group_controller";
application.register("type-picker-group", TypePickerGroupController);

import ExerciseUploadController from "./exercise_upload_controller";
application.register("exercise-upload", ExerciseUploadController);

import ExerciseReplaceController from "./exercise_replace_controller";
application.register("exercise-replace", ExerciseReplaceController);

import ExerciseVideoController from "./exercise_video_controller";
application.register("exercise-video", ExerciseVideoController);

import AudioRecorderController from "./audio_recorder_controller";
application.register("audio-recorder", AudioRecorderController);

import ExerciseAudioController from "./exercise_audio_controller";
application.register("exercise-audio", ExerciseAudioController);

import StudentAudioResponseController from "./student_audio_response_controller";
application.register("student-audio-response", StudentAudioResponseController);

import AudioPlayerController from "./audio_player_controller";
application.register("audio-player", AudioPlayerController);

import FillBlanksEditorController from "./fill_blanks_editor_controller";
application.register("fill-blanks-editor", FillBlanksEditorController);

import FillBlanksStudentController from "./fill_blanks_student_controller";
application.register("fill-blanks-student", FillBlanksStudentController);

import WordBankFillStudentController from "./word_bank_fill_student_controller";
application.register("word-bank-fill-student", WordBankFillStudentController);

import MultipleChoiceFillStudentController from "./multiple_choice_fill_student_controller";
application.register("multiple-choice-fill-student", MultipleChoiceFillStudentController);

import AutoSubmitController from "./auto_submit_controller";
application.register("auto-submit", AutoSubmitController);

import UrlSyncController from "./url_sync_controller";
application.register("url-sync", UrlSyncController);

import ClassroomPresenceController from "./classroom_presence_controller";
application.register("classroom-presence", ClassroomPresenceController);

import VideoFullscreenController from "./video_fullscreen_controller";
application.register("video-fullscreen", VideoFullscreenController);

import VideoMediaToggleController from "./video_media_toggle_controller";
application.register("video-media-toggle", VideoMediaToggleController);

import VideoCallController from "./video_call_controller";
application.register("video-call", VideoCallController);

import CallButtonController from "./call_button_controller";
application.register("call-button", CallButtonController);

import VocabularyPopoverController from "./vocabulary_popover_controller";
application.register("vocabulary-popover", VocabularyPopoverController);

import PronunciationController from "./pronunciation_controller";
application.register("pronunciation", PronunciationController);

import ImageCropperController from "./image_cropper_controller";
application.register("image-cropper", ImageCropperController);

import WordImageMatchEditorController from "./word_image_match_editor_controller";
application.register("word-image-match-editor", WordImageMatchEditorController);

import WordImageMatchNewFormController from "./word_image_match_new_form_controller";
application.register("word-image-match-new-form", WordImageMatchNewFormController);

import WordImageMatchPlayerController from "./word_image_match_player_controller";
application.register("word-image-match-player", WordImageMatchPlayerController);

import WordImageTypeEditorController from "./word_image_type_editor_controller";
application.register("word-image-type-editor", WordImageTypeEditorController);

import WordImageTypeNewFormController from "./word_image_type_new_form_controller";
application.register("word-image-type-new-form", WordImageTypeNewFormController);

import WordImageTypePlayerController from "./word_image_type_player_controller";
application.register("word-image-type-player", WordImageTypePlayerController);

import WordImageSelectEditorController from "./word_image_select_editor_controller";
application.register("word-image-select-editor", WordImageSelectEditorController);

import WordImageSelectNewFormController from "./word_image_select_new_form_controller";
application.register("word-image-select-new-form", WordImageSelectNewFormController);

import WordImageSelectOptionsController from "./word_image_select_options_controller";
application.register("word-image-select-options", WordImageSelectOptionsController);

import WordImageSelectPlayerController from "./word_image_select_player_controller";
application.register("word-image-select-player", WordImageSelectPlayerController);

import TestCountdownController from "./test_countdown_controller";
application.register("test-countdown", TestCountdownController);

import TestPlayerController from "./test_player_controller";
application.register("test-player", TestPlayerController);

import ChoiceQuizEditorController from "./choice_quiz_editor_controller";
application.register("choice-quiz-editor", ChoiceQuizEditorController);

import ChoiceQuizPlayerController from "./choice_quiz_player_controller";
application.register("choice-quiz-player", ChoiceQuizPlayerController);

import ChatComposerController from "./chat_composer_controller";
application.register("chat-composer", ChatComposerController);

import ChatController from "./chat_controller";
application.register("chat", ChatController);

import ChatAudioPlayerController from "./chat_audio_player_controller";
application.register("chat-audio-player", ChatAudioPlayerController);

import ChatButtonController from "./chat_button_controller";
application.register("chat-button", ChatButtonController);

import ChatPaginationController from "./chat_pagination_controller";
application.register("chat-pagination", ChatPaginationController);

import LessonNavController from "./lesson_nav_controller";
application.register("lesson-nav", LessonNavController);

import HomeworkPickerController from "./homework_picker_controller";
application.register("homework-picker", HomeworkPickerController);

// Expose application instance for system tests and browser debugging.
window.Stimulus = application;

export { application };
